<template>
  <!-- 电子分类排行 -->
  <a-layout-content>
    <div>
      <span>分类类型：</span>
      <a-select style="width: 150px" v-model="type" @change="qryListAPI">
        <a-select-option value="1"> 周排行</a-select-option>
        <a-select-option value="2"> 月排行</a-select-option>
      </a-select>
      &nbsp;
      <a-button type="primary" @click="add()" v-if="role191">添加分类</a-button>
    </div>
    <br />
    <a-table
      size="middle"
      :columns="columns"
      row-key="ID"
      :data-source="data"
      :pagination="false"
      :scroll="{ y: 500 }"
      bordered
    >
      <template slot="operation" slot-scope="text, record">
        <a href="javascript:;" @click="edit(record)" v-if="role192">
          <a-icon type="edit" style="font-size: 22px"></a-icon>
        </a>
        <template v-if="role193">
          &nbsp;
          <a-popconfirm title="确定要删除?" @confirm="() => onDelete(record)">
            <a href="javascript:;">
              <a-icon type="delete" style="font-size: 22px"></a-icon>
            </a>
          </a-popconfirm>
        </template>
      </template>
    </a-table>

    <!-- 对话框 ------------------------------------->
    <a-modal
      v-model="visible"
      :title="modaltype === 0 ? '新增'+typeName+'分类' : '编辑'+typeName+'分类'"
      @ok="handleOk"
    >
      <a-form-model
        ref="ruleForm"
        :rules="rules"
        :model="form"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="分类名称" ref="Tname" prop="Tname">
          <a-input v-model="form.Tname" placeholder="分类名称" />
        </a-form-model-item>
        <a-form-model-item label="排序字段" ref="Index" prop="Index">
          <a-input
            v-model.number="form.Index"
            placeholder="请输入排序"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-layout-content>
</template>
<script>
import { isNumber } from "../../js/textverify";

export default {
  data() {
    return {
      role190: false,//电子分类榜查询
      role191: false,//电子分类榜添加
      role192: false,//电子分类榜修改
      role193: false,//电子分类榜删除
      visible: false,
      modaltype: 0,
      data: [],
      columns: [
        {
          title: "编号",
          dataIndex: "ID",
          align: "center",
          width: "10%",
        },
        {
          title: "分类名称",
          dataIndex: "Tname",
          align: "center",
          width: "40%",
        },
        {
          title: "排序字段",
          dataIndex: "Index",
          align: "center",
          width: "20%",
        },
        {
          title: "操作",
          dataIndex: "operation",
          align: "center",
          width: "30%",
          scopedSlots: { customRender: "operation" },
        },
      ],
      form: {},
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      rules: {
        Index: [
          { required: true, message: "请输入排序", trigger: "blur" },
          { validator: isNumber, trigger: "change" },
        ],
        Tname: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
      },
      type:"1",
      typeName:'周'
    };
  },
  methods: {
    onDelete(val) {
      const that = this;
      this.$confirm({
        title: "删除期别",
        content:
          "是否要删除该分类?当删除该分类后,对应分类的排行榜数据将一并清除!!",
        onOk() {
          that.axios.post("/slotpvp/deleteslotpvpterm", { id: val.ID }).then((res) => {
            if (res.data) {
              that.$message.success("删除成功");
              that.qryListAPI();
            }
          });
        },
      });
    },
    add() {
      this.modaltype = 0;
      this.form = {};
      this.form.ID = 0;
      this.form.Type = this.type;
      this.typeName = this.type === "1" ? "周" :"月";
      this.visible = true;
    },
    edit(val) {
      this.modaltype = 1;
      this.form = val;
      this.typeName = this.type === "1" ? "周" :"月";
      this.visible = true;
    },
    //对话框确认按钮
    handleOk() {
      const that = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const method = that.modaltype === 0 ? "/slotpvp/addslotpvpterm" : "/slotpvp/setslotpvpterm";
          that.axios.post(method, that.form).then((res) => {
            if (res.data) {
              const mes = that.modaltype === 0 ? "添加成功" : "编辑成功";
              that.$message.success(mes);
              this.visible = false;
              that.qryListAPI();
            }
            else{
              that.$message.warning(res.error);
            }
          });
        }
      });
    },
    // 查询API
    qryListAPI() {
      this.axios.post("/slotpvp/getslotpvpterm", { Type: this.type }).then((res) => {
        if (res.data) {
          this.data = res.data;
        }
      });
    },
  },
  //首次加载
  created() {
    this.qryListAPI();
    //获取权限
    const array = JSON.parse(sessionStorage.RoleID);
    const roleID = [190, 191, 192,193];
    var isRole = roleID.filter(function (item) {
      return array.indexOf(item) != -1;
    });
    //功能权限获取
    isRole.forEach((element) => {
      this["role" + element] = true;
    });
  },
};
</script>

<style>
.red {
  color: rgb(255, 0, 0);
}
</style>


// WEBPACK FOOTER //
// src/components/slotpvp/classification.vue